import { useGetPartnersQuery } from '@/apiSlices';
import { useEffect, useMemo, useState } from 'react';
import { useSelectedPartnerId } from '@/redux/partners-slice.ts';
import { Partner } from '@/redux/types.ts';

const recentPartnersKey = 'recentPartners';

const getRecentPartners = (): string[] => {
	try {
		return JSON.parse(localStorage.getItem(recentPartnersKey) || '[]');
	} catch (e) {}

	return [];
};

export const useRecentPartners = () => {
	const { data: partners = [] } = useGetPartnersQuery({});
	const selectedPartnerId = useSelectedPartnerId();
	const [recentPartnerKeys, setRecentPartnerKeys] = useState<string[]>(getRecentPartners());
	const selectedPartnerKey = useMemo(
		() => partners.find(({ id }) => id === selectedPartnerId)?.partnerKey,
		[partners, selectedPartnerId]
	);

	const recentPartners = useMemo<Partner[]>(
		() =>
			recentPartnerKeys
				.map((key) => partners.find(({ partnerKey }) => partnerKey === key))
				.filter(Boolean) as Partner[],

		[partners, recentPartnerKeys]
	);

	useEffect(() => {
		if (selectedPartnerKey && partners.length) {
			setRecentPartnerKeys((recentPartnerKeys) => {
				const filteredRecentPartnerKeys = recentPartnerKeys.filter((key) => key !== selectedPartnerKey);
				const newState = [selectedPartnerKey, ...filteredRecentPartnerKeys].slice(0, 3);
				localStorage.setItem(recentPartnersKey, JSON.stringify(newState));
				return newState;
			});
		}
	}, [selectedPartnerKey, partners]);

	return recentPartners;
};
